const MeasurementStatCard = ({icon, label, value, unit, hasData}: {icon: JSX.Element, label: string, value: string | number, unit: string, hasData: boolean}) => (
    <div className="d-flex flex-column" style={{border: hasData ? '1px solid #EFF2F5' : '1px dashed #E4E6EF', background: hasData ? '#F9FAFB' : '#FBFBFD', borderRadius: 7, padding: '9px 9px'}}>
        <div className="d-flex align-items-center mb-1" style={{color: hasData ? '#009EF7' : '#C9CCD9'}}>
            {icon}
            <span className="ms-1 fw-semibold text-uppercase" style={{fontSize: 9, letterSpacing: '.04em', color: hasData ? '#A1A5B7' : '#B5B5C3'}}>{label}</span>
        </div>
        {hasData ? (
            <div className="fw-bold" style={{fontSize: 17, lineHeight: 1, color: '#181C32'}}>
                {value}<span style={{fontSize: 10, fontWeight: 500, color: '#A1A5B7', marginLeft: 3}}>{unit}</span>
            </div>
        ) : (
            <div style={{height: 17, display: 'flex', alignItems: 'center'}}>
                <span style={{display: 'inline-block', width: 22, height: 8, borderRadius: 4, background: '#E8EAF0'}}/>
            </div>
        )}
    </div>
)

export default MeasurementStatCard
